export default [
  { url: '/images/cactus.svg', width: 57, height: 87 },
  { url: '/images/coffee.svg', width: 75, height: 83 },
  { url: '/images/flag.svg', width: 94, height: 71 },
  { url: '/images/glasses.svg', width: 80, height: 68 },
  { url: '/images/guitar.svg', width: 50, height: 158 },
  { url: '/images/island.svg', width: 70, height: 84 },
  // { url: '/images/JS_Book.svg', width: 68, height: 32 },
  { url: '/images/lightingBart.svg', width: 30, height: 41 },
  { url: '/images/luggages.svg', width: 83, height: 80 },
  { url: '/images/macintosh.svg', width: 58, height: 82 },
  { url: '/images/macSad.svg', width: 49, height: 35 },
  { url: '/images/pizza.svg', width: 59, height: 100 },
  { url: '/images/record.svg', width: 75, height: 60 },
  { url: '/images/taco.svg', width: 55, height: 51 },
  { url: '/images/vans.svg', width: 94, height: 50 },
]



// WEBPACK FOOTER //
// ./src/utilities/images.js